import React from 'react';
import CropCategory from '../screens/CropListing/CropCategory';

const TestNewLayoutPage = () => {
    return (
        <CropCategory />
    );
};

export default TestNewLayoutPage;
